"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function YourAgreementWithUs() {
  const {
    ref: cardRef,
    isVisible: cardVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  return <section className="relative bg-background py-16 px-4 md:py-24">
      <div className="container mx-auto max-w-6xl">
        <div ref={cardRef} className={`
            card mx-auto max-w-4xl
            transition-all duration-[var(--duration-medium)]
            ${cardVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}
          `}>
          <div className="p-8 md:p-12">
            <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground-secondary mb-8">
              Terms and Conditions
            </h2>

            <div className="space-y-6 text-foreground-light text-sm md:text-base leading-relaxed">
              <p className="font-semibold text-foreground-secondary">
                PLEASE READ CAREFULLY. BY USING OUR SERVICE, YOU SIGNIFY YOUR ACCEPTANCE OF THESE TERMS OF USE. 
                IF YOU DO NOT AGREE WITH ANY OF THE TERMS OF USE BELOW, PLEASE DO NOT USE OUR SERVICE. CAR SERVICE CONNECTICUT RESERVES THE RIGHT, AT ANY TIME, TO MODIFY, ALTER OR UPDATE THESE TERMS OF USE. YOU AGREE TO BE BOUND BY SUCH MODIFICATIONS, ALTERATIONS, OR UPDATES.
              </p>

              <div className="space-y-4">
                <h3 className="font-display text-xl md:text-2xl font-semibold text-foreground-secondary border-b-2 border-muted/40 pb-2">
                  Reservations
                </h3>
                <p>We recommend that our clients reserve a car ahead of time (at no additional charge) to be guaranteed a vehicle. We can provide you with a vehicle at short notice by phone or online upon availability. Once the reservation is booked and processed by one of our representatives, and if a customer wishes to cancel/make changes after that point, they must do so 24 hours prior to the scheduled pickup. Changes/cancelations made after the 24 hour mark will be handled on a case-by-case basis. </p>
              </div>

              <div className="space-y-4">
                <h3 className="font-display text-xl md:text-2xl font-semibold text-foreground-secondary border-b-2 border-muted/40 pb-2">
                  No-Shows
                </h3>
                <p>
                  If you do not see your driver at a certain pickup point, do not leave before calling the dispatch office at (203) 872-9965. We will direct you to your chauffeur. If you leave without calling, you will be billed for the full price of the ride (or a no-show fee). If we do not hear from you, the driver will wait up to 30 minutes at regular pickups and up to 60 minutes at airport pickups after the scheduled pickup time. We will then try to reach you by calling you on your cell phone, all depending on the nature of the pickup. If we do not get a response, we will release the car. You will be billed for a No Show, which will be the Full Price of the ride (or a no show fee) plus any waiting time charges. To authorize the driver to wait, please call the office to authorize his wait. If we do not hear from you after the time frame, we will contact you again; if no contact is made, you will get billed for the ride plus the waiting time. Therefore A "No Show" fee is equal to the trip cost, plus the applicable wait time fee will be charged when the passenger fails to arrive at the designated location. If you cannot locate your Driver, Please call (203) 872-9965 to avoid a "No Show" Fee.
                </p>
              </div>

              <div className="space-y-4">
                <h3 className="font-display text-xl md:text-2xl font-semibold text-foreground-secondary border-b-2 border-muted/40 pb-2">
                  Diverted And Canceled Flights
                </h3>
                <p>
                  Car Service Connecticut will monitor the flight until the vehicle is dispatched. If the flight is delayed after that point, there may be additional wait charges. If the flight is diverted, there will be a "No-Show" fee or additional wait time if you authorize us to wait for the flight to arrive at the new time.
                </p>
              </div>

              <div className="space-y-4">
                <h3 className="font-display text-xl md:text-2xl font-semibold text-foreground-secondary border-b-2 border-muted/40 pb-2">
                  Damages Resulting From Your Act
                </h3>
                <p>
                  Car Service Connecticut will charge you the cost of cleaning the vehicle due to you or your authorized party getting sick in or damaging the vehicle. You also agree and acknowledge to pay all the related fees and charges to get the vehicle back to its normal working condition. If the vehicle is put out of commission due to damages resulting from your party, you will be responsible for compensating Car Service Connecticut for lost revenue until the vehicle is returned to service.
                </p>
              </div>

              <div className="space-y-4">
                <h3 className="font-display text-xl md:text-2xl font-semibold text-foreground-secondary border-b-2 border-muted/40 pb-2">
                  Alcohol Consumption
                </h3>
                <p>
                  By law, alcohol consumption is permitted ONLY in vehicles with a divider (limousines). Alcohol is PROHIBITED in standard vehicles without a divider/partition between the passengers and the driver.
                </p>
              </div>

              <div className="space-y-4">
                <h3 className="font-display text-xl md:text-2xl font-semibold text-foreground-secondary border-b-2 border-muted/40 pb-2">
                  Food and Drinks
                </h3>
                <p>
                  There are NO open container foods allowed in all Car Service Connecticut vehicles. Only bottled drinks are allowed.
                </p>
              </div>

              <div className="space-y-4">
                <h3 className="font-display text-xl md:text-2xl font-semibold text-foreground-secondary border-b-2 border-muted/40 pb-2">
                  Credit Card Transactions
                </h3>
                <p>
                  We take an authorization for the full amount on the card to guarantee funds availability 48-72 hours prior to the scheduled ride. It may show as "Pending" or "Posted" if you check your credit card account statement online. The authorization amount may be higher than the expected charges in the event you decide to make additional stops or change your destination. We will then finalize the charges on your card after the trip has been completed. All receipts are sent by email. We have a secure 128-bit SSL encrypted payment. By submitting payment details you consent to the detection and storage of your IP address to help guard against credit card fraud.
                </p>
              </div>

              <div className="space-y-4">
                <h3 className="font-display text-xl md:text-2xl font-semibold text-foreground-secondary border-b-2 border-muted/40 pb-2">
                  Disputes
                </h3>
                <p>
                  Corporate clients with established corporate accounts: All charges of the invoice will be considered correct and due upon receipt unless we receive an objection within 10 days from the invoice date. Copies of the vouchers under dispute should be emailed to us and the disputed charges or items should be indicated. All disputes initiated after the allowed time frame period will be considered final and non-refundable.
                </p>
                <p>
                  Individual accounts and personal profiles: All charges applied to the customer's credit card will be considered correct unless we receive an objection within 15 days from the charge date. All disputes initiated after the allowed time frame period will be considered final and non-refundable.
                </p>
              </div>

              <div className="space-y-4">
                <h3 className="font-display text-xl md:text-2xl font-semibold text-foreground-secondary border-b-2 border-muted/40 pb-2">
                  Collection Fees
                </h3>
                <p>
                  You agree to pay all legal counseling fees, litigation fees, legal fees, costs, accounting fees, expenses, and disbursements for all actions taken prior to, during, and subsequent to the initiation of legal proceedings to collect payments due in cases of non-payment.
                </p>
              </div>

              <div className="space-y-4">
                <h3 className="font-display text-xl md:text-2xl font-semibold text-foreground-secondary border-b-2 border-muted/40 pb-2">
                  Rates Changes
                </h3>
                <p>
                  Car Service Connecticut can change the rates and any of the services, charges, costs, fees, and expenses at any time without prior notice.
                </p>
              </div>

              <div className="space-y-4">
                <h3 className="font-display text-xl md:text-2xl font-semibold text-foreground-secondary border-b-2 border-muted/40 pb-2">
                  Pricing Errors and Glitches
                </h3>
                <p>
                  While we make every effort to provide you with the most accurate, up-to-date pricing, occasionally, one or more items on our website may be incorrectly priced. Car Service Connecticut shall have the right to refuse or cancel any orders placed for products listed at the incorrect price.
                </p>
              </div>

              <div className="space-y-4">
                <h3 className="font-display text-xl md:text-2xl font-semibold text-foreground-secondary border-b-2 border-muted/40 pb-2">
                  Itemized Invoices
                </h3>
                <p>
                  Corporate clients with established corporate accounts: Itemized invoices will be sent regularly as "Due upon receipt" at the end of each month.
                </p>
                <p>
                  Individual accounts and personal profiles: Itemized invoices are sent only when requested.
                </p>
              </div>

              <div className="space-y-4">
                <h3 className="font-display text-xl md:text-2xl font-semibold text-foreground-secondary border-b-2 border-muted/40 pb-2">
                  Payment Due Date
                </h3>
                <p>
                  Corporate clients with established corporate accounts: All payments should be received no later than 15 days from the invoice date unless otherwise agreed on in the contract. Payments not received within the time frame allowed shall occur interest charges added of 30% yearly or 2.5% monthly.
                </p>
                <p>
                  Individual accounts and personal profiles: All payments should be received before executing the ride.
                </p>
              </div>

              <div className="space-y-4">
                <h3 className="font-display text-xl md:text-2xl font-semibold text-foreground-secondary border-b-2 border-muted/40 pb-2">
                  Point To Point Fare
                </h3>
                <p>
                  Point-to-Point Service is calculated based on mileage and zones. This service is not for a set period of time, just the time needed to travel from point A to point B. If you need a vehicle for a specific number of hours, please reserve the hourly service.
                </p>
              </div>

              <div className="space-y-4">
                <h3 className="font-display text-xl md:text-2xl font-semibold text-foreground-secondary border-b-2 border-muted/40 pb-2">
                  Hourly Rates
                </h3>
                <p>
                  Packages of vehicles rented hourly (restrictions apply). Hourly services provided have a 2 hour minimum. Hourly charge is calculated based on the time the vehicle is scheduled to pick up in the designated area to when the vehicle drops off in the designated area.
                </p>
              </div>

              <div className="space-y-4">
                <h3 className="font-display text-xl md:text-2xl font-semibold text-foreground-secondary border-b-2 border-muted/40 pb-2">
                  Waiting Time
                </h3>
                <p>
                  Car Service Connecticut provides 30 minutes for domestic and 60 minutes for international flights based on the reported flight arrival time for airport pickups only. A 15 minute grace period is granted for all other pickups. After the grace period ends, the charges will accrue from the original pick up time. Waiting time will be charged at 1-minute increments (at the rates listed below) after the grace period. Wait time and additional charges are subject to taxes, tip, and surcharge.
                </p>
                <p>
                  Car Service Connecticut monitors all domestic and international flights 45 minutes before the driver is dispatched. Billing starts after grace period allowed from the official time the flight touches down. We are unable to monitor private flights. If you are flying on a private flight, please notify us if there are any delays or changes to your itinerary.
                </p>
                <p className="font-semibold text-foreground-secondary mt-4">Wait time rates:</p>
                <ul className="list-disc list-inside space-y-1 ml-4">
                  <li>Sedan: $1.10/minute</li>
                  <li>SUVs: $1.50/minute</li>
                  <li>Sprinter Vans: $2.50/minute</li>
                </ul>
              </div>

              <div className="space-y-4">
                <h3 className="font-display text-xl md:text-2xl font-semibold text-foreground-secondary border-b-2 border-muted/40 pb-2">
                  Stops
                </h3>
                <p>
                  Price per stop is $25. Courtesy stops, such as briefly leaving the vehicle to use the restroom, do not incur extra charges. However, if longer stops or multiple stops are made, you will be billed stop charges. Picking up additional passengers will also incur stop charges.
                </p>
              </div>

              <div className="space-y-4">
                <h3 className="font-display text-xl md:text-2xl font-semibold text-foreground-secondary border-b-2 border-muted/40 pb-2">
                  Tolls
                </h3>
                <p>
                  All tolls are based on a round trip to and from the designated destination and are added onto the reservation after it has been created.
                </p>
              </div>

              <div className="space-y-4">
                <h3 className="font-display text-xl md:text-2xl font-semibold text-foreground-secondary border-b-2 border-muted/40 pb-2">
                  Meet & Greet
                </h3>
                <p>
                  Meet and Greet Airport Service is offered at an additional charge of $25. The driver will be instructed to meet the passenger by the baggage claim or the exit of customs with a sign that has his or her last name on it. The driver will then escort the passenger to the vehicle, assisting with the luggage.
                </p>
              </div>

              <div className="space-y-4">
                <h3 className="font-display text-xl md:text-2xl font-semibold text-foreground-secondary border-b-2 border-muted/40 pb-2">
                  Luggage
                </h3>
                <p>
                  Car Service Connecticut is not responsible for damage to luggage or the contents in the luggage.
                </p>
              </div>

              <div className="space-y-4">
                <h3 className="font-display text-xl md:text-2xl font-semibold text-foreground-secondary border-b-2 border-muted/40 pb-2">
                  Parking
                </h3>
                <p>
                  All parking fees and other airport regulatory fees are additional (usually $10.00-$15.00 depending on time). We do not charge them; these fees go directly to the airport parking lots.
                </p>
              </div>

              <div className="space-y-4">
                <h3 className="font-display text-xl md:text-2xl font-semibold text-foreground-secondary border-b-2 border-muted/40 pb-2">
                  Gratuity
                </h3>
                <p>
                  A tip (gratuity) is added to every trip. There is no need to tip anything additional to the drivers unless you would like to.
                </p>
              </div>

              <div className="space-y-4">
                <h3 className="font-display text-xl md:text-2xl font-semibold text-foreground-secondary border-b-2 border-muted/40 pb-2">
                  Baby Seats
                </h3>
                <p>
                  Car Service Connecticut provides baby seats for an additional cost of $15 per seat. Please mention that you will need a baby seat when you place your reservation.
                </p>
              </div>

              <div className="space-y-4">
                <h3 className="font-display text-xl md:text-2xl font-semibold text-foreground-secondary border-b-2 border-muted/40 pb-2">
                  Service Error
                </h3>
                <p>
                  In the event of a vehicle breakdown or service error, Car Service Connecticut will make every attempt to provide a replacement vehicle that is equivalent to the original reservation. Car Service Connecticut cannot be held liable for missed reservations/appointments due to a service error.
                </p>
              </div>

              <p className="text-xs text-muted mt-8 pt-4 border-t border-muted/40">
                Last Updated: January 2025
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}